export default "/images/vendor/flag-icon-css/flags/1x1/ac.svg?e104704cd04bb0cb7c7221284727f7c1";